// Product Enquiry Link Handler
// Updates enquiry link URL when variant changes

document.addEventListener('DOMContentLoaded', function () {
  const enquiryLink = document.querySelector('.product-enquiry-link');

  if (!enquiryLink) {
    return;
  }

  // Get base URL parts from initial link
  const baseUrl = new URL(enquiryLink.href);
  const contactPagePath = baseUrl.pathname;
  const productParam = baseUrl.searchParams.get('product');
  const productUrlParam = baseUrl.searchParams.get('product_url');

  // Function to update the enquiry link with current variant
  function updateEnquiryLink(variant) {
    if (!variant) return;

    // Build new URL with updated variant
    let newUrl = `${contactPagePath}?product=${encodeURIComponent(productParam)}`;

    if (productUrlParam) {
      newUrl += `&product_url=${encodeURIComponent(productUrlParam)}`;
    }

    // Add SKU parameter if available, otherwise fallback to variant title
    if (variant.sku && variant.sku !== '') {
      newUrl += `&sku=${encodeURIComponent(variant.sku)}`;
    } else if (variant.title && variant.title !== 'Default Title') {
      newUrl += `&variant=${encodeURIComponent(variant.title)}`;
    }

    // Update the link href
    enquiryLink.href = newUrl;
  }

  // Listen for variant change events
  document.addEventListener('theme:variant:change', function (event) {
    if (event.detail && event.detail.variant) {
      updateEnquiryLink(event.detail.variant);
    }
  });

  // Initialize with current variant on page load
  const productJson = document.querySelector('[data-product-json]');
  if (productJson) {
    try {
      const product = JSON.parse(productJson.textContent);
      const hiddenVariantInput = document.querySelector('input[name="id"]');
      const selectedVariantId = hiddenVariantInput ? parseInt(hiddenVariantInput.value) : null;
      const initialVariant = selectedVariantId
        ? product.variants.find((v) => v.id === selectedVariantId)
        : product.variants[0];

      if (initialVariant) {
        updateEnquiryLink(initialVariant);
      }
    } catch (e) {
      console.error('Error initializing enquiry link:', e);
    }
  }
});
